import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

import Counter from "./Counter";

function InfoDescriptor({ value, unit, topText, topUnit, bottomLabel }) {
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div
          className="info-descriptor"
          style={getVisibleSensorAnimation(isVisible, "fadeIn 1s")}
        >
          {topText && (
            <span
              className={`info-descriptor__top-text${setAdditionalClasses(
                ["info-descriptor--top-unit"],
                [topUnit]
              )}`}
            >
              {topText}
            </span>
          )}
          {topUnit && (
            <div className="info-descriptor__top-unit">{topUnit}</div>
          )}
          <p className="info-descriptor__value">
            {
              <Counter
                value={value}
                unit={unit}
                enableVisibilityAnimation={false}
              />
            }
          </p>
          {bottomLabel && <span>{bottomLabel}</span>}
        </div>
      )}
    </VisibilitySensor>
  );
}

export default InfoDescriptor;
